/* eslint-disable import/prefer-default-export */
import InsertDriveFileOutlinedIcon from "@mui/icons-material/InsertDriveFileOutlined";
import BoltOutlinedIcon from "@mui/icons-material/BoltOutlined";
import ReportProblemOutlinedIcon from "@mui/icons-material/ReportProblemOutlined";
import StorageOutlinedIcon from "@mui/icons-material/StorageOutlined";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import WatchLaterOutlinedIcon from "@mui/icons-material/WatchLaterOutlined";
import HelpOutlineOutlinedIcon from "@mui/icons-material/HelpOutlineOutlined";
import { SvgIconComponent } from "@mui/icons-material";
import { ScheduleType } from "enums/schedule.enum";
import { humanize } from "utils/common";

export interface IScheduleTypeDisplay {
    label: string;
    code: string;
    icon: SvgIconComponent;
    iconColor: string;
}

export const DEFAULT_SCHEDULE_TYPE_KEY = "DEFAULT";

export const scheduleTypeDisplayMap: Record<string, IScheduleTypeDisplay> = {
    [ScheduleType.GENERATE_REPORTS]: {
        label: "Generate Reports",
        code: ScheduleType.GENERATE_REPORTS,
        icon: InsertDriveFileOutlinedIcon,
        iconColor: "#E040A0",
    },
    [ScheduleType.EXTRACT_EVENTS]: {
        label: "Extract Events",
        code: ScheduleType.EXTRACT_EVENTS,
        icon: BoltOutlinedIcon,
        iconColor: "#5B8DEF",
    },
    [ScheduleType.EXTRACT_INCIDENTS]: {
        label: "Extract Incidents",
        code: ScheduleType.EXTRACT_INCIDENTS,
        icon: ReportProblemOutlinedIcon,
        iconColor: "#F5A623",
    },
    [ScheduleType.EXTRACT_REFERENCE_DATA]: {
        label: "Extract Reference Data",
        code: ScheduleType.EXTRACT_REFERENCE_DATA,
        icon: StorageOutlinedIcon,
        iconColor: "#7C5CFC",
    },
    [ScheduleType.GENERATE_FILE]: {
        label: "Generate File",
        code: ScheduleType.GENERATE_FILE,
        icon: FileDownloadOutlinedIcon,
        iconColor: "#2FBF9F",
    },
    [ScheduleType.UPDATE_REAL_TIME_COUNTER]: {
        label: "Update Real Time Counter",
        code: ScheduleType.UPDATE_REAL_TIME_COUNTER,
        icon: WatchLaterOutlinedIcon,
        iconColor: "#EF5DA8",
    },
    [DEFAULT_SCHEDULE_TYPE_KEY]: {
        label: "Unknown",
        code: DEFAULT_SCHEDULE_TYPE_KEY,
        icon: HelpOutlineOutlinedIcon,
        iconColor: "#9AA5B1",
    },
};

export const getScheduleTypeDisplay = (type: string): IScheduleTypeDisplay => {
    const match = scheduleTypeDisplayMap[type];
    if (match) {
        return match;
    }
    return {
        ...scheduleTypeDisplayMap[DEFAULT_SCHEDULE_TYPE_KEY],
        label: humanize(type),
        code: type,
    };
};
